import { render, staticRenderFns } from "./deptSelect.vue?vue&type=template&id=6293eb3e&scoped=true"
import script from "./deptSelect.vue?vue&type=script&lang=js"
export * from "./deptSelect.vue?vue&type=script&lang=js"
import style0 from "./deptSelect.vue?vue&type=style&index=0&id=6293eb3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6293eb3e",
  null
  
)

export default component.exports